
export function createWhereTextSearch(text, fields) {
    let items = [];
    const regex = /(-|)(?:"(.*?)"|\b(\S+)\b)/gm;
    var m
    while ((m = regex.exec(text)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        if (m[2]) {
            items.push({
                v: m[2],
                negate: m[1] == "-"
            })
        } else {
            items.push({
                v: m[3],
                negate: m[1] == "-"
            })
        }
    }

    if (items.length === 0) {
        return "(true)"
    }

    const c = '(' + fields
        .map(field => "(" + items
            .map(item => `${field} ${item.negate ? 'NOT ' : ''}LIKE '%${item.v}%'`)
            .join(" AND ") + ")"
        ).join(" OR ") + ')'

    return c
}